<template>
  <div class="col-lg-8 col-md-8 col-12 detail-right">
    <router-link
      class="font-size-16 secondary-color-txt font-sanpro-semibold"
      to="/lop-hoc/noi-dung"
    >
      <i class="fa fa-angle-left"></i> Trở lại
    </router-link>
    <div class="swiper-week text-center">
      <!-- <div class="btn-prev">
        <img src="@/assets/images/prev.png" alt />
      </div>
      <h3 class="primary-color font-sanpro-semibold font-size-16">Tuần 1: TÔI VÀ CÁC BẠN</h3>
      <h3 class="secondary-color-txt font-size-16 font-family-Semibold">06/01/2021 - 12/01/2021</h3>
      <h3 class="secondary-color-txt font-size-16 font-family-Semibold">05 bài - 18 tài liệu</h3>
      <div class="btn-next">
        <img src="@/assets/images/next.png" alt />
      </div>-->

      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide v-for="(item, index) in getListLesonPlan" :key="index">
          <h3 class="primary-color font-sanpro-semibold font-size-16">{{item.title}}</h3>
          <h3
            class="secondary-color-txt font-size-16 font-family-Semibold"
          >{{moment(item.fromDate).format(formatDate1)}} - {{moment(item.toDate).format(formatDate1)}}</h3>
          <h3
            class="secondary-color-txt font-size-16 font-family-Semibold"
          >{{item.numberOfLesson}} bài - {{item.numberOfDocument}} tài liệu</h3>
        </swiper-slide>

        <div class="swiper-button-prev btn-prev" slot="button-prev"></div>
        <div class="swiper-button-next btn-next" slot="button-next"></div>
      </swiper>
    </div>

    <div class="lesson" v-for="(item, index) in subjectLists" :key="index">
      <h2 class="primary-color font-sanpro-semibold font-size-16">{{item.title}}</h2>
      <div class="lesson-textbook item-lesson">
        <router-link :to="{name:'ebook-read-book' ,params:{slug:item.sgk.slug,id:item.sgk.bookId}}">
          <img src="@/assets/img/icon-textbook.png" alt />
          {{item.sgk.title}}
        </router-link>
      </div>
      <div
        class="lesson-document item-lesson"
        v-for="(item2,index2) of item.documents"
        :key="index2"
      >
        <a to="/#" @click="previewDoc(item2)">
          <img src="@/assets/img/icon-document.png" alt />
          {{item2.name}}
        </a>
      </div>
      <div class="lesson-pratice item-lesson">
        <router-link to="/#">
          <img src="@/assets/img/icon-practice.png" alt /> Luyện Tập
        </router-link>
      </div>
    </div>
    	<div class="show-document" v-if="visiblePreviewModal">
	        <div class="inner-content js-model active">
	        	<ModalPreviewDocMedia />
	        	<div class="js-background-model active" @click="handleOffModal"></div>
	        </div>
	    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { STORE_KEY } from "../../_store/constants";
import moment from "moment";
import "swiper/dist/css/swiper.css";
import { APP_CONFIG } from '@/utils/constants'
import { LOCAL_SAVE_CHRISTMAS_CARD } from "../../_store/constants";
import ModalPreviewDocMedia from "../../../../components/content-files/ModalPreviewDocMedia";
import { swiper, swiperSlide } from "vue-awesome-swiper";
export default {
  name: "carrousel",
  components: {
    ModalPreviewDocMedia,
    swiper,
    swiperSlide
  },
  data() {
    const vue = this;
    return {
      indexActive: 0,
      lessonPlanId: this.$route.params.lessonPlanId,
      formatDate1: "DD/MM/YYYY",
      indexAction: 0,
      data: 0,
      swiperOption: {
        notNextTick: true,
        autoHeight: true,
        runCallbacksOnInit: true,
        // initialSlide :0,
        onSlideChangeEnd: function() {
          this.onSwipe();
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
    };
  },
  // watch:{
  //   getListLesonPlan(newVal,oldVal){
  //     // indexAction
  //       newVal.list.forEach((value, index) => {
  //         if(this.indexAction == index){
  //           this.lessonPlanId = value.lessonPlanId;
  //           alert(this.lessonPlanId)
  //         }
  //       });
  //   }
  // },
  computed: {
    ...mapGetters({
      subjectLists: STORE_KEY + "/subjectLists",
      getListLesonPlan: STORE_KEY + "/getListLesonPlan",
      visiblePreviewModal: 'common/visiblePreviewModal',
    }),
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },

  mounted() {
    this.actionGetListSubjectInWeek(this.lessonPlanId);
    this.swiper.activeIndex = localStorage.getItem(LOCAL_SAVE_CHRISTMAS_CARD);
    this.swiper.on("slideChange", () => {
      this.onSwipe(this);
    });
  },

  methods: {
    ...mapActions(`${STORE_KEY}`, ["actionGetListSubjectInWeek"]),
    ...mapActions('common', ['toggleModalPreview', 'setDocPreviewContent']),
    moment,
    onSwipe(varuable) {
      this.indexAction = varuable.swiper.activeIndex;
      this.getListLesonPlan.forEach((value, index) => {
        if (this.indexAction == index) {
          this.lessonPlanId = value.lessonPlanId;
        }
      });
      this.actionGetListSubjectInWeek(this.lessonPlanId);
    },
    previewDoc(item){
      	this.setDocPreviewContent(item)
				this.toggleModalPreview(true)
    },
    handleOffModal() {
				this.toggleModalPreview(false)
				this.setDocPreviewContent({})
		}
  }
};
</script>

<style lang="scss" scoped>
.swiper-week {
  border-top: 1px solid #e8e6e6;
  border-bottom: 1px solid #e8e6e6;
  padding: 17px 0 8px 0;
  position: relative;
  h3,
  .btn-prev,
  .btn-next {
    cursor: pointer;
    right: 10px;
  }
  .btn-prev {
    left: 10px;
    img {
      position: absolute;
      left: 24px;
      height: 45px;
      top: 28px;
    }
  }
  .btn-next {
    img {
      position: absolute;
      right: 24px;
      height: 45px;
      top: 28px;
    }
  }
}
.lesson {
  padding: 15px 20px;
  background: #f3f6fb;
  border-radius: 8px;
  margin-top: 18px;
  .item-lesson {
    padding: 7px 15px;
    background: #fff;
    border-radius: 5px;
    margin-top: 12px;
    a {
      color: #40505e;
    }
  }
  img {
    height: 15px;
    margin-right: 10px;
  }
}
.dropdown-account {
  margin-left: 10px;
}
.dropdown button {
  width: 30px;
  background: #f3f6fb;
  color: #879aa9;
  font-size: 14px;
  text-align: center;
  border: 0px;
  padding-left: 0px;
  padding-right: 0px;
  border-radius: 30px;
  height: 30px;
  outline: 0;
}
.dropdown-item:hover,
.dropdown-item:focus {
  color: #124abe;
  text-decoration: none;
  background: #f3f6fb;
}
.dropdown button:focus {
  background: #f3f6fb !important;
  color: #124abe;
}
.dropdown-toggle::after {
  display: none;
}
.dropdown-menu {
  padding: 0rem 0 0.5rem;
  margin: 0.125rem 0 0;
  box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
  transform: translate3d(-95px, 30px, 0px) !important;
}
@media (max-width: 425px) {
  .dropdown-menu {
    padding: 0rem 0 0.5rem;
    margin: 0.125rem 0 0;
    box-shadow: 1px -1px 7px rgba(0, 0, 0, 0.3);
    transform: translate3d(167px, 30px, 0px) !important;
  }
  .list-class .add-search {
    display: block;
    .btns {
      margin-bottom: 20px;
    }
  }
}
</style>